export default {
  update(el, binding) {
    if (binding.value) {
      el.focus()
    }
  }
}
